/* eslint-disable no-underscore-dangle */
import axios from 'axios';

function environmentIsInitialized() {
  return !!(window.envs && window.envs.VUE_APP_IS_LOADED);
}

function initializeDeployedEnvironment() {
  if (environmentIsInitialized()) {
    return;
  }

  window.envs = JSON.parse(window.__GLOBAL_ENVS__);
  window.envs.VUE_APP_IS_LOADED = true;
  delete window.__GLOBAL_ENVS__;
}

function isInDeployedEnvironment() {
  return process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'systest' || process.env.NODE_ENV === 'prod';
}

export function isInLocalEnvironment() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'jest';
}

export function getEnv(environmentKey) {
  if (isInLocalEnvironment()) {
    return process.env[environmentKey];
  }

  if (!environmentIsInitialized()) {
    initializeDeployedEnvironment();
  }

  return window.envs[environmentKey];
}

export function populateEnvs() {
  if (isInLocalEnvironment()) {
    return process.env;
  }

  return window.envs;
}

export default async function initializeEnvironment() {
  if (isInDeployedEnvironment()) {
    initializeDeployedEnvironment();
  }
  axios.defaults.baseURL = getEnv('VUE_APP_API_BASE_URL');
}
